<mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>

<div class="spinner" *ngIf="loading"><mat-progress-spinner mode="indeterminate"></mat-progress-spinner></div>

<h1>{{ locale.translations['header']['n6'] }}</h1>

<form [formGroup]="form" (ngSubmit)="onSubmit()">
	<div class="mdc-layout-grid__inner">
		<div class="mdc-layout-grid__cell--span-12" *ngIf="phone">
			<mat-form-field appearance="standard" hideRequiredMarker>
				<mat-label>{{ locale.translations['logup']['login']['n229'] }}</mat-label>

				<input matInput dir="ltr" type="text" [value]="phone" [ngStyle]="{ 'text-align': locale.lang === 'en' ? 'left' : 'right' }" disabled />
			</mat-form-field>

			<a *ngIf="user['userType'] === '0'" class="cursor-pointer" (click)="onUpdateMobile()">
				{{ locale.translations['user']['user-profile']['n244'] }}
			</a>
		</div>

		<div class="mdc-layout-grid__cell--span-12 n42">
			<mat-form-field appearance="standard" hideRequiredMarker>
				<mat-label>{{ locale.translations['logup']['signup']['n42'] }}</mat-label>

				<input matInput required [placeholder]="locale.translations['user']['user-profile']['n160']" type="text" formControlName="name" />
			</mat-form-field>
		</div>

		<div class="mdc-layout-grid__cell--span-12" id="n79">
			<button mat-flat-button type="submit" color="primary" [disabled]="!form.dirty || loading">
				{{ locale.translations['user']['user-profile']['n79'] }}
			</button>
		</div>

		<div class="mdc-layout-grid__cell--span-12" *ngIf="user['userType'] === '0'">
			<a class="delete cursor-pointer" [class.pe-none]="loading" (click)="onDelete()">{{ locale.translations['user']['user-profile']['n247'] }}</a>
		</div>
		<!-- 
		<div class="mdc-layout-grid__cell--span-12" *ngIf="user['userType'] === '0'">
			<a [routerLink]="['/dealer-benefits']" class="dealer">{{ locale.translations['dealer']['n363'] }}</a>
		</div> -->
	</div>
</form>
